import { render, staticRenderFns } from "./value-config-detail.vue?vue&type=template&id=56689a62&"
import script from "./value-config-detail.vue?vue&type=script&lang=js&"
export * from "./value-config-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports